// Unpublished Work © 2020-2024 Deere & Company.

export const MAX_FILE_SIZE = 20;
export const MEMBERSHIP_LOGO_DIR = '/NSM01/static/prod/ongolf/memberships';
export const USER_PROFILE_PIC_DIR = '/NSM01/static/prod/ongolf/users';
